import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarEquipesDeVendasController } from "../../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import { ListarPontosDeVendaController } from "../../../../Controllers/Vendas/GestãoDeVisitas/GestãoDeVisitasControllers";
import { IGestaoDeVisitasBody } from "../../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { useRef, useState } from "react";
import Select from "react-select";
import { ListarUsuarioEquipeVendasController } from "../../../../Controllers/Vendas/EquipeVendas/UsuarioEquipeVenda/UsuarioEquipeVenda";

const filtroInicial: IGestaoDeVisitasBody = {
    DT_INICIO: "",
    DT_FIM: "",
    DS_CLIENTE: "",
    ID_EQUIPE_VENDAS: [],
    ID_PONTO_VENDA: 0,
    DS_STATUS: "",
};

interface IGestaoDeVisitasResponseProps {
    handleFilter: (filter: IGestaoDeVisitasBody) => void;
    defaultFilter?: IGestaoDeVisitasBody;
}
export default function FiltroDeVisitas(props: IGestaoDeVisitasResponseProps) {
    const filter = props.defaultFilter;
    const FormMethods = useForm();
    const { reset } = FormMethods;

    const equipeVendasRef = useRef<any>(null);

    const [selectedEquipeVendas, setSelectedEquipeVendas] = useState<number[]>(
        []
    );

    const { value: lstEquipesDeVendas } = useAsyncEffect(
        () => ListarEquipesDeVendasController(),
        []
    );

    const { value: lstUsuarios } = useAsyncEffect(async () => {
        if (selectedEquipeVendas) {
            return ListarUsuarioEquipeVendasController(selectedEquipeVendas);
        }
    }, [selectedEquipeVendas]);

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    return (
        <>
            <StickyToolbar active={Boolean(filter)}>
                <FormProvider {...FormMethods}>
                    <UnForm handleSubmit={props.handleFilter} usingContext>
                        <div className="col-12 mt-3">
                            <label>Data Inicio</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_INICIO"
                                defaultValue={filter?.DT_INICIO}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_FIM"
                                defaultValue={filter?.DT_FIM}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Nome</label>
                            <UnForm.Input
                                className="form-control"
                                name="DS_CLIENTE"
                                defaultValue={filter?.DS_CLIENTE}
                            />
                        </div>

                        <div className="col-12 mt-3">
                            <label>Equipes Vendas</label>
                            <Select
                                ref={equipeVendasRef}
                                name="ID_EQUIPE_VENDAS"
                                isMulti
                                options={
                                    lstEquipesDeVendas?.map((e) => ({
                                        label: e.DS_EQUIPE_VENDAS,
                                        value: e.ID_EQUIPE_VENDAS,
                                    })) || []
                                }
                                defaultValue={
                                    filter?.ID_EQUIPE_VENDAS?.map((id) => ({
                                        label: lstEquipesDeVendas?.find(
                                            (e) => e.ID_EQUIPE_VENDAS === id
                                        )?.DS_EQUIPE_VENDAS,
                                        value: id,
                                    })) || []
                                }
                                onChange={(e) => {
                                    setSelectedEquipeVendas(
                                        e.map((item) => item.value)
                                    );
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() =>
                                    "Nenhuma equipe de vendas encontrada."
                                }
                                {...FormMethods}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Corretor</label>
                            <UnForm.Select
                                name="ID_USUARIO_RESPONSAVEL"
                                defaultValue={filter?.ID_USUARIO_RESPONSAVEL}
                            >
                                <option></option>
                                {lstUsuarios?.map((e) => (
                                    <option value={e.ID_USUARIO}>
                                        {e.DS_NOME}
                                    </option>
                                ))}
                            </UnForm.Select>
                        </div>

                        <div className="col-12 mt-3">
                            <label>Ponto de Venda</label>
                            <UnForm.LazySelect
                                name="ID_PONTO_VENDA"
                                controller={ListarPontosDeVendaController}
                                getDS={(e) => e.DS_PONTO_VENDA}
                                getKeyValue={(e) => e.ID_PONTO_VENDA}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>

                        <div className="col-12 mt-3">
                            <label>Status</label>
                            <UnForm.Select
                                className="form-control"
                                name="DS_STATUS"
                                defaultValue={filter?.DS_STATUS}
                            >
                                <option value=""></option>
                                <option value="Agendadas">Agendadas</option>
                                <option value="Realizadas">Realizadas</option>
                                <option value="Pendentes">Pendentes</option>
                            </UnForm.Select>
                        </div>

                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_GESTAO_VISITAS"
                                    );
                                    equipeVendasRef.current.clearValue();
                                    reset(filtroInicial);
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar>
        </>
    );
}
